import React from 'react';
import ChoreManagerGrid from './ChoreManagerGrid';
import './App.css';

function App() {
  return <ChoreManagerGrid />;
}

export default App;
